import { NgModule }            from '@angular/core';
import { FileDropInputModule } from '@shared/components/file-drop/file-drop-input/file-drop-input.module';
import { FileDropTableModule } from '@shared/components/file-drop/file-drop-table/file-drop-table.module';


@NgModule( {
	declarations: [],
	imports: [
		// FileDrop
		FileDropInputModule,
		FileDropTableModule
	],
	exports: [
		// FileDrop
		FileDropInputModule,
		FileDropTableModule
	]
} )
export class FileDropModule {}
